import classNames from "classnames";
import { ChangeEvent } from "react";
import { components, GroupBase, InputProps } from "react-select";

import { AutocompleteAddress } from "@/services/bpost.service";

type InputComponentProps = InputProps<
    AutocompleteAddress,
    false,
    GroupBase<AutocompleteAddress>
>;

type ExtraProps = {
    placeholder?: string;
    setInputValue: (inputValue: string) => void;
    loadOptions: (inputValue: string) => Promise<void>;
    openMenu: () => void;
};

type BPostAddressFieldInputComponentProps = Omit<
    InputComponentProps,
    "value" | "placeholder"
> &
    ExtraProps;

export const BPostAddressFieldInputComponent = ({
    placeholder,
    setInputValue,
    loadOptions,
    openMenu,
    ...props
}: BPostAddressFieldInputComponentProps) => {
    const handleOnChange = async (event: ChangeEvent<HTMLInputElement>) => {
        setInputValue(event.target.value);
        await loadOptions(event.target.value);
        openMenu();
    };

    return (
        <components.Input
            {...props}
            placeholder={placeholder}
            className={classNames(props.className, "bPostAddressField__input")}
            onChange={handleOnChange}
        />
    );
};

export const createBPostAddressFieldInputComponent =
    (extraProps: ExtraProps) => (props: InputComponentProps) => (
        <BPostAddressFieldInputComponent
            {...props}
            {...extraProps}
        />
    );
